import React from 'react';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import { space, SpaceProps } from 'styled-system';

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement>, SpaceProps {
  src: string;
  alt?: string;
}

const StyledLazyImage = styled.img<SpaceProps>`
  ${space}
`;

const LazyImage = ({ alt, loading = 'lazy', ...props }: LazyImageProps) => {
  return <StyledLazyImage loading='lazy' {...props} alt={alt ?? ''} />;
};



export default LazyImage;
